// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"tn_a bii_b bii_bj","StrollerbaseBanner__hint":"tn_b bii_vh","StrollerbaseBanner__link":"tn_c"};